/*@flow*/
import React, { useState, Fragment } from 'react';
import { value2Option, dropdownStyles } from '../utils';
import { Async as AsyncSelect } from 'react-select';
import getBbox from 'lib/getBbox';
import filterByLabel from 'lib/filterByLabel';
import GetLayers from '../../queries/GetLayers';
import type { LocalsT } from 'lib/proforma/types';
import ErrorsView from 'comps/ErrorsView';
import textbox from 'lib/proforma/templates/Textbox';
import client from 'store/apollo';
import * as I from 'immutable';

function Input(locals: LocalsT) {
  const { onChange, value } = locals;
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [options, setOptions] = useState([]);
  const bbox = getBbox();

  const loadOptions = () => {
    setLoading(true);
    setErrors([]);

    const variables: { [key: string]: any } = { bbox };

    return client
      .query({ query: GetLayers, variables })
      .then(({ data }) => {
        setLoading(false);
        const pathToLayers = ['layers'];
        const opts = I.getIn(data, pathToLayers, []).map((v) => ({
          label: v.name,
          value: v.id,
        }));
        setOptions(opts);
        return opts;
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err);
      });
  };

  return (
    <Fragment>
      <ErrorsView errors={errors} />
      <AsyncSelect
        loadOptions={loadOptions}
        styles={dropdownStyles}
        isLoading={loading}
        placeholder={loading ? 'Loading...' : 'Search for a layer'}
        filterOption={filterByLabel}
        value={value2Option(value, options)}
        className="data-panel-layer"
        name="data-panel-layer"
        cacheOptions
        defaultOptions
        isClearable
        onChange={(o) => {
          if (o) {
            onChange(o.value);
          } else {
            onChange(null);
          }
        }}
      />
    </Fragment>
  );
}

export default (textbox.clone({ Input }): any);
